export class Header {

    static init() {
        Header.mobileMenu();
        //
    }

    static mobileMenu() {
        var $ = jQuery;

        // Hamburger
        $(document.body).on('click', '.js-mobile-menu', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $header = $this.closest('.js-header');
            //
            if ($header.hasClass('is-opened')) {
                $header.removeClass('is-opened');
            } else {
                $header.addClass('is-opened');
            }
        });

        // Children item
        $(document.body).on('click', '.menu-item-has-children > a', function (e) {
            e.preventDefault();
            //
            var $this = $(this);
            var $li = $this.closest('li');
            //
            if ($li.hasClass('is-opened')) {
                $li.removeClass('is-opened');
            } else {
                $li.addClass('is-opened');
            }
        });
    }
}